<template>
  <div>
    <div class="card">
      <!---内容变更--->
      <div class="section">
        <div class="section-title">
          <base-section-title title="内容变更" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="changeInfo.changeInfo || {}"
            :option="contentOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          />
        </div>
      </div>

      <!---变更公告--->
      <div class="section">
        <div class="section-title">
          <base-section-title title="变更公告" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="changeInfo.notice || {}"
            :option="noticeOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          >
            <template v-slot:content>
              <u-editor disabled :value="content" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'

import { noticeReleaseStatusDict } from '@/dictionary/project/common'

// api接口
import { getNegotiationV2NewestChangeInfoApi } from '@/api/procure/negotiation-v2'

import DateUtils from '@/utils/date'

export default {
  components: {
    BaseSectionTitle,
    UEditor
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      changeInfo: {},
      contentOptions: [
        {
          label: '报价申请时间',
          prop: '',
          filter: value => DateUtils.getNormMinuteRange(value.offerStartTime, value.offerEndTime)
        },
        {
          label: '谈判地点',
          filter: value => {
            if (value?.country === '中国') {
              return `${value?.province} - ${value?.city} - ${value?.area}`
            } else {
              return `${value?.country}`
            }
          }
        },
        {
          label: '详细地址',
          prop: 'address'
        }
      ],
      noticeOptions: [
        {
          label: '发布日期',
          prop: 'releaseTime',
          isNormDay: true
        },
        {
          label: '发布状态',
          prop: 'releaseStatus',
          dictArray: noticeReleaseStatusDict.array,
          useTag: true
        },
        {
          label: '变更公告标题',
          prop: 'title'
        },
        {
          label: '变更公告内容',
          prop: 'content',
          slotName: 'content'
        }
      ]
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },
    content() {
      return this.changeInfo?.notice?.content || ''
    }
  },

  watch: {
    'requestQuery.orderId': {
      handler: function(val) {
        if (val) {
          this.getChangeInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    // 获取最新变更信息
    getChangeInfo() {
      if (!this.orderId) return
      getNegotiationV2NewestChangeInfoApi(this.orderId)
        .then(res => {
          this.changeInfo = res.data || {}
          this.$emit('setChangeInfo', this.changeInfo)
        })
        .catch(err => {
          this.$message.error(err.message || '获取信息失败')
        })
    }
  }
}
</script>
